import authHeader from 'srcReact/helpers/auth-header'
import { doRequestAxios, } from 'srcReact/helpers/apiHelper'

export const discoverService = {
  getDiscoverAll,
  getMixrList,
  getGroupList,
}

function getDiscoverAll(
  id_workplace,
  group_list_order_by,
  group_list_latitude,
  group_list_longitude,
  group_list_offset,
  group_list_quantity,
  mixr_list_order_by,
  mixr_list_latitude,
  mixr_list_longitude,
  mixr_list_offset,
  mixr_list_quantity
) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      id_workplace,
      group_list_order_by,
      group_list_latitude,
      group_list_longitude,
      group_list_offset,
      group_list_quantity,
      mixr_list_order_by,
      mixr_list_latitude,
      mixr_list_longitude,
      mixr_list_offset,
      mixr_list_quantity,
    },
  }
  return doRequestAxios(`/v2/discover/all`, requestOptions)
}

function getMixrList(id_workplace, order_by, latitude, longitude, offset, quantity) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { id_workplace, order_by, latitude, longitude, offset, quantity },
  }
  return doRequestAxios(`/v2/discover/mixr-list`, requestOptions)
}


function getGroupList(id_workplace, order_by, latitude, longitude, offset, quantity) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { id_workplace, order_by, latitude, longitude, offset, quantity },
  }
  return doRequestAxios(`/v2/discover/group-list`, requestOptions)
}


